import { Autocomplete, Paper } from '@mui/material';
import { styled } from '@mui/system';

interface StyledAutocompleteProps {
  width?: string;
  dropboxwidth?: string;
}

const StyledAutocomplete = styled(Autocomplete)<StyledAutocompleteProps>(
  ({ width }) => ({
    '& .MuiAutocomplete-inputRoot': {
      width: width,
    },
  })
);

const StyledPaper = styled(Paper)<StyledAutocompleteProps>(
  ({ dropboxwidth }) => ({
    width: dropboxwidth,
    left: 0,
    right: 0,
  })
);

export { StyledAutocomplete, StyledPaper };
